import { Component, Input } from '@angular/core';
import * as animations from '../../animations';

@Component({
  selector: 'tr-icon-status',
  animations: [animations.BounceInAnimation],
  templateUrl: './icon-status.component.html',
  //styleUrls: ['./icon-status.component.scss']
})
export class IconStatusComponent {

  @Input() currentStage: Object;

}



// WEBPACK FOOTER //
// ./src/app/shared/components/icon-status/icon-status.component.ts